export default {
  'Resolution': 'Resolution',
  'Frame rate': 'Frame rate',
  'The higher the frame rate, the smoother the animation': 'The higher the frame rate, the smoother the animation.',
}